import './style.scss';

/**
 * Gallery Masonry Effect — frontend script (Pro)
 */

const isEditor =
	document.body.classList.contains('block-editor-page') ||
	document.body.classList.contains('editor-styles-wrapper') ||
	!!document.querySelector('.editor-styles-wrapper');

function resizeMasonryItem(item) {
	const grid = item.closest('.wp-block-gallery.is-layout-masonry');
	if (!grid) return;

	// In editor, we rely completely on CSS Columns. JS stops here.
	if (isEditor) return;

	// Reset span to calculate true height.
	item.style.gridRowEnd = 'auto';

	let targetForMargin =
		item.tagName.toLowerCase() === 'figure'
			? item
			: item.querySelector('figure');
	if (!targetForMargin) targetForMargin = item;

	const rect = item.getBoundingClientRect();
	const itemStyle = window.getComputedStyle(targetForMargin);
	const totalHeight =
		rect.height +
		(parseFloat(itemStyle.marginBottom) || 0) +
		(parseFloat(itemStyle.marginTop) || 0);

	// grid-auto-rows is 1px, so 1 span = 1px.
	item.style.gridRowEnd = `span ${Math.ceil(totalHeight)}`;
}

function resizeAllMasonryItems() {
	document
		.querySelectorAll(
			'.wp-block-gallery.is-js-masonry > .wp-block-image, .wp-block-gallery.is-js-masonry > figure.wp-block-image'
		)
		.forEach(resizeMasonryItem);
}

function initGallery(gallery) {
	if (gallery.classList.contains('is-js-masonry')) return;

	gallery.classList.add('is-js-masonry');

	gallery
		.querySelectorAll('.wp-block-image, figure.wp-block-image')
		.forEach((item) => {
			const img = item.querySelector('img');
			if (img) {
				if (img.complete) {
					resizeMasonryItem(item);
				} else {
					img.addEventListener('load', () => resizeMasonryItem(item));
				}
			} else {
				resizeMasonryItem(item);
			}
		});
}

function scanForGalleries(root = document) {
	root.querySelectorAll('.wp-block-gallery.is-layout-masonry').forEach(
		initGallery
	);
}

scanForGalleries();

if (isEditor) {
	new MutationObserver(() => scanForGalleries()).observe(document.body, {
		childList: true,
		subtree: true,
	});
}

let resizeTimer;
window.addEventListener('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(resizeAllMasonryItems, 100);
});
